<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="交通模拟"
      id="scenerModel"
      :close="close"
      ref="scenerModel"
    >
      <template slot="head">
        <div class="head-operate">
          <el-button type="primary" @click="addSimulationAata">
            <i class="el-icon-zengjia"></i> 新增方案
          </el-button>
          <!-- {{ statusPlay }} -->
          <el-button
            v-show="statusPlay == 'suspend'"
            type="primary"
            @click="batchPlay"
            :disabled="ifAddModal"
          >
            <i class="las la-play-circle"></i> 播放
          </el-button>
          <el-button
            v-show="statusPlay == 'play'"
            type="primary"
            @click="batchSuspend"
            :disabled="ifAddModal"
          >
            <i class="las la-stop-circle"></i> 停止
          </el-button>
          <!-- <el-button type="primary" @click="importList">
            <i class="el-icon-zengjia"></i> 导入数据
          </el-button> -->
        </div>
      </template>
      <!-- <template slot="foot">
        <div class="foot-operate">
          <el-button v-if="selectedScene" type="primary" @click="verification">
            加入场景
          </el-button>
        </div>
      </template> -->
    </MapModal>
    <Add
      v-show="ifAddModal"
      :currentState="currentState"
      :close="addModalClose"
      @refresh="getTreeNodeList"
      ref="addTree"
    ></Add>
    <AddSpot
      v-if="ifAddSpot"
      :close="addSpotClose"
      :addSpotId="addSpotId"
      @refresh="getTreeNodeList"
      ref="addSpot"
    ></AddSpot>

    <EditSpot
      v-show="ifEditSpot"
      :close="editSpotClose"
      :editSpotId="editSpotId"
      @refresh="getTreeNodeList"
      ref="editSpot"
    ></EditSpot>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const Add = () => import("./Add.vue");
const AddSpot = () => import("@/components/tables/fixedRoute/AddSpot.vue");
const EditSpot = () => import("@/components/tables/fixedRoute/EditSpot.vue");

//按需加载
import {
  getTreeNodeList,
  getProjectBimModel,
  deleteTdeeeiorst,
} from "@/api/api";
import * as mapWork from "./trafficSimulation.js";
export default {
  name: "traffic-simulation",
  components: { MapModal, Add, AddSpot, EditSpot },
  props: ["close"],
  // props: {
  //   getSchemeTree: { type: Function },
  //   selectedScene: { type: Object },
  //   modalNodeData: { type: Array },
  //   close: {
  //     type: Function,
  //   },
  // },
  data() {
    return {
      show: false,
      checkedData: [],
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      statusPlay: "suspend",
      modalNode: {
        fixedRoute: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -425,
            // unit: "px", // 默认px
          },
          width: "380px", // 宽度配置 默认450px
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            80}px`, // 配置模态框中心高度
          // height: "350px",
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "modalTree", // id和ref使用的同一个
            name: "text", // 树的展示字段 默认name
            expand: false,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            expandClick: true,
            i_icon: {
              level_1: "fa fa-car",
              level_2: "las la-map-marker",
            },
            search: {
              keywords: "text", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            checkeArr: [],
            check: this.checkBoxClick,
            nodeClick: this.nodeClick,
          },
        },
      },
      ifAddModal: false,
      ifAddSpot: false,
      ifEditSpot: false,
      currentState: "add",
      editSpotId: "",
      addSpotId: "",
      projectId: window.sessionStorage.getItem("nowProjectId"),
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // 获取树形数据
    getTreeNodeList() {
      let modelData = {
        ProjectId: window.sessionStorage.getItem("nowProjectId"),
        dataType: 1,
      };
      getTreeNodeList(modelData)
        .then((res) => {
          if (res.data.code == 200 || res.data.code == 204) {
            mapWork.getRequestData(res.data.data);
            res.data.data.forEach((item) => {
              item.operate = [
                // {
                //   i_icon: "small-operation-btn el-icon-view",
                //   click: (e) => this.ifExhibition(e),
                // },
                {
                  i_icon: "small-operation-btn el-icon-zengjia",
                  click: (e) => this.addSpot(e),
                },
                {
                  i_icon: "small-operation-btn el-icon-edit",
                  click: (e) => this.edit(e),
                },
                {
                  i_icon: "small-operation-btn el-icon-delete",
                  click: (e) => this.delete(e),
                },
              ];
              item.children.forEach((i) => {
                i.operate = [
                  {
                    i_icon: "small-operation-btn el-icon-edit",
                    click: (e, index) => this.editSpot(e, index),
                  },
                  {
                    i_icon: "small-operation-btn el-icon-delete",
                    click: (e) => this.deleteSpot(e),
                  },
                ];
              });
            });
            this.modalNode.fixedRoute.content.treeDataJson = res.data.data;
          } else {
            this.$message({
              message: "请求失败，请稍后再试",
              type: "error",
              offset: 100,
              showClose: true,
              duration: 1600,
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: "请求失败，请稍后再试",
            type: "error",
            offset: 100,
            showClose: true,
            duration: 1600,
          });
        });
    },
    edit(e) {
      console.log(e);
      this.ifAddSpot = false;
      this.ifEditSpot = false;
      this.ifAddModal = true;
      this.currentState = "edit";
      this.statusPlay = "suspend";
      let { id, text, bimTrafficSimulationNode, children } = e;
      let { speed, interval, importData, position } = bimTrafficSimulationNode;
      let positionArr = [];
      children.forEach((item) => {
        positionArr.push(
          item.bimTrafficSimulationContent.contentValue.split(",")
        );
      });

      this.$refs.addTree.submitData.id = id;
      this.$refs.addTree.submitData.name = text;
      this.$refs.addTree.submitData.position = positionArr;
      this.$refs.addTree.submitData.importData = importData;
      this.$refs.addTree.submitData.interval = interval;
      this.$refs.addTree.submitData.speed = speed;

      console.log("判断", id, this.$GLOBAL.map.getLayer(id, "czmlId"));

      mapWork.postAverageVelocity(bimTrafficSimulationNode.speed);
      mapWork.postIntervalvehicle(e.bimTrafficSimulationNode.interval);
      // mapWork.clearDots();
      mapWork.routePointSet.push(positionArr);
      mapWork.simulationStart(positionArr, e.id, true);
      mapWork.drawLine(mapWork.routePointSet[0], true);
    },
    addSimulationAata() {
      this.batchSuspend();
      this.ifAddSpot = false;
      this.ifEditSpot = false;
      this.ifAddModal = true;
      this.currentState = "add";
      this.statusPlay = "suspend";
      this.$refs.addTree.submitData = {
        id: "",
        name: "",
        positionType: "1",
        position: [],
        importData: "",
        speed: "45",
        interval: "1",
      };
      this.$refs.addTree.modalNode.trafficSimulationAdd.content.formData.positionType.show = true;
      this.$refs.addTree.modalNode.trafficSimulationAdd.content.formData.position.show = true;
      this.$refs.addTree.modalNode.trafficSimulationAdd.content.formData.importData.show = false;
    },
    delete(e) {
      deleteTdeeeiorst({
        id: e.id,
      })
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.getTreeNodeList();
            this.$notify({
              title: "删除成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
          } else {
            this.$notify({
              title: "删除失败",
              message: "",
              type: "error",
              duration: 960,
              offset: 320,
            });
          }
        })
        .catch((err) => {
          this.$notify({
            title: "删除失败",
            message: "",
            type: "error",
            duration: 960,
            offset: 320,
          });
        });
    },
    nodeClick(e) {
      if (this.$GLOBAL.map.getLayer(e.id, "czmlId") != undefined) {
        let { children } = e;
        let positionArr = [];
        children.forEach((item) => {
          positionArr.push(
            item.bimTrafficSimulationContent.contentValue.split(",")
          );
        });
        mapWork.drawLine(mapWork.routePointSet[0], true, false);
      }
    },
    checkBoxClick(e, node) {
      let arr;
      arr = node.checkedNodes.filter((item) => {
        return item.children.length > 0;
      });
      this.checkedData = arr;
    },
    addModalClose() {
      this.ifAddModal = false;
      // mapWork.stopDraw();
      if (this.currentState == "add") {
        mapWork.init("add");
      } else {
        mapWork.init();
        this.statusPlay = "suspend";
      }
    },
    addSpotClose(e) {
      this.ifAddSpot = false;
    },
    batchSuspend() {
      mapWork.init();
      this.statusPlay = "suspend";
    },
    batchPlay() {
      if (this.checkedData.length == 0) {
        this.$notify({
          title: "请选择一个方案",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
        return false;
      }
      this.statusPlay = "play";
      this.ifAddSpot = false;
      this.ifAddModal = false;
      mapWork.clearDots();
      mapWork.clearLine();
      this.checkedData.forEach((item) => {
        this.ifExhibition(item);
      });
    },
    ifExhibition(e) {
      if (this.ifAddModal) {
        this.addModalClose();
      }
      console.log("判断", e.id, this.$GLOBAL.map.getLayer(e.id, "czmlId"));
      if (this.$GLOBAL.map.getLayer(e.id, "czmlId")) {
        mapWork.clearCZML(e.id);
      } else {
        let { children, bimTrafficSimulationNode } = e;
        // 更新速度
        // 更新时间
        if (children.length > 0) {
          let position = [];
          mapWork.postAverageVelocity(bimTrafficSimulationNode.speed);
          mapWork.postIntervalvehicle(e.bimTrafficSimulationNode.interval);
          children.forEach((item) => {
            position.push(
              item.bimTrafficSimulationContent.contentValue.split(",")
            );
          });
          mapWork.routePointSet.push(position);
          mapWork.simulationStart(position, e.id, true);
        }
      }
    },
    addSpot(e) {
      mapWork.refresh();
      this.statusPlay = "suspend";
      this.ifAddSpot = true;
      this.ifAddModal = false;
      let { children } = e;
      let positionArr = [];
      children.forEach((item) => {
        positionArr.push(
          item.bimTrafficSimulationContent.contentValue.split(",")
        );
      });
      mapWork.routePointSet.push(positionArr);
      mapWork.drawLine(positionArr);
      mapWork.drawDots(children);
      this.addSpotId = e.id;
    },
    editSpot(e, node) {
      this.ifEditSpot = true;
      this.ifAddModal = false;
      this.ifAddSpot = false;
      this.editSpotId = e.id;
      // this.statusPlay = "suspend";
      this.$refs["editSpot"].edit(
        e,
        node,
        this.modalNode.fixedRoute.content.treeDataJson
      );
    },
    deleteSpot(e) {
      this.$refs["editSpot"].delete(e);
    },
    editSpotClose() {
      mapWork.refresh();
      this.ifEditSpot = false;
    },
    init() {
      this.getTreeNodeList();
    },
    mapWorkInit() {
      mapWork.init();
      this.statusPlay = "suspend";
    },
  },
  mounted() {
    this.init();
  },
  destroyed() {
    mapWork.init();
  },
  watch: {
    // modalNodeData: function(newVal, oldVal) {
    //   newVal[0].children.forEach((item) => {
    //     this.checkedIds.push(item.bimModel.embsId);
    //     // this.modalNode.planDemo.content.checkeArr = this.checkedIds;
    //     this.$refs.scenerModel.$refs.modalTree[0].checkChangeArr(
    //       this.checkedIds
    //     );
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0 5px 0 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
.head-operate {
  padding: 10px 10px;
  margin: 0 -5px !important;
  button {
    margin: 0 5px !important;
  }
}
/deep/ .el-tree-node__children .el-tree-node__content .el-checkbox {
  display: none;
}
</style>
